(function () {
  window.setCookie = function(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  window.addUpsellToCart = function(target) {
    if (target.getAttribute('disabled') === 'disabled') {
      return;
    }
  
    // Get variant ID from either the button's data attribute or the variant selector
    let variantId = target.getAttribute('data-variant-id');
    const productId = target.getAttribute('data-product-id');
    
    // Check if there's a variant selector for this product
    const upsellProduct = target.closest('.upsell-product');
    const variantSelect = upsellProduct ? upsellProduct.querySelector('.upsell-variant-select') : null;
    
    if (variantSelect) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantId = selectedOption.value;
      
      // Check if selected variant is still available
      if (selectedOption.dataset.available !== 'true') {
        alert('Sorry, this size is no longer available. Please select a different size.');
        return;
      }
    }
    
    let quantity = 1;

    // Find the closest quantity input if it exists (upsellProduct already defined above)
    const quantityInput = upsellProduct ? upsellProduct.querySelector('.upsell-quantity-input') : null;
    
    if (quantityInput) {
      // Get the value and ensure it's within bounds
      quantity = parseInt(quantityInput.value) || 1;
      const min = parseInt(quantityInput.getAttribute('min')) || 1;
      const max = parseInt(quantityInput.getAttribute('max')) || 1;

      if (quantity < min) {
        quantity = min;
        quantityInput.value = min;
      } else if (quantity > max) {
        quantity = max;
        quantityInput.value = max;
      }
    }

    // Show loading state
    target.style.opacity = '0.5';
    target.setAttribute('disabled', 'disabled');
    
    // Change button text to show loading
    const originalText = target.innerHTML;
    target.innerHTML = 'Adding...';

    // Use Shopify's AJAX cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw err;
        });
      }
      return response.json();
    })
    .then(data => {
      // Restore button
      target.innerHTML = originalText;
      handleUpsellSuccess(target, data);
    })
    .catch(error => {
      // Restore button
      target.innerHTML = originalText;
      handleUpsellError(target, { 
        responseText: JSON.stringify(error) 
      }, 'error');
    });
  };

  // Handle successful upsell addition
  function handleUpsellSuccess(target, item) {
    // Reset button state
    target.style.opacity = '1';
    target.removeAttribute('disabled');
    
    // Show success feedback
    const originalText = target.innerHTML;
    target.innerHTML = '✓ Added!';
    target.style.backgroundColor = '#28a745';
    
    // Reset button after delay
    setTimeout(() => {
      target.innerHTML = originalText;
      target.style.backgroundColor = '';
    }, 2000);

    // Fetch updated cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header
        updateCartCount(cart.item_count);
        
        // Update cart drawer/page if it exists
        updateCartDisplay(cart);
        
        // Open cart drawer or show notification
        openCartDrawer();
        
        // Dispatch custom event for other scripts to listen to
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart }
        }));
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });

    // Dispatch custom event for other scripts to listen to
    document.dispatchEvent(new CustomEvent('upsell:item-added', {
      detail: { item: item, target: target }
    }));
  }

  // Update cart count in header
  function updateCartCount(itemCount) {
    const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count');
    cartCountElements.forEach(element => {
      element.textContent = itemCount;
      
      // Show/hide bubble based on count
      const bubble = element.closest('.cart-count-bubble');
      if (bubble) {
        if (itemCount > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      }
    });
  }

  // Update cart drawer/page display
  function updateCartDisplay(cart) {
    // Update free shipping progress bar if function exists
    if (window.updateFreeShippingProgress) {
      window.updateFreeShippingProgress(cart.total_price);
    }
    
    // Check if cart drawer exists and is visible
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      // Fetch and update cart drawer content
      fetch('/cart?view=drawer')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartContent = doc.querySelector('#CartDrawer');
          
          if (newCartContent) {
            // Update the cart drawer content
            cartDrawer.innerHTML = newCartContent.innerHTML;
            
            // Reinitialize any cart drawer scripts if needed
            if (window.theme && window.theme.initCartDrawer) {
              window.theme.initCartDrawer();
            }
          }
        })
        .catch(error => {
          console.error('Error updating cart drawer:', error);
        });
    }
    
    // Check if we're on the cart page
    const cartPage = document.querySelector('form[action="/cart"]');
    if (cartPage) {
      // Reload cart page content
      fetch('/cart')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartForm = doc.querySelector('form[action="/cart"]');
          
          if (newCartForm && cartPage.parentNode) {
            cartPage.parentNode.replaceChild(newCartForm, cartPage);
          }
        })
        .catch(error => {
          console.error('Error updating cart page:', error);
        });
    }
  }

  // Open cart drawer
  function openCartDrawer() {
    const cartDrawer = document.querySelector('#CartDrawer');
    
    if (cartDrawer) {
      // Try multiple methods to open the drawer
      
      // Method 1: Look for cart drawer button and trigger click
      const cartButton = document.querySelector('[data-cart-drawer], .cart-drawer-toggle, #cart-icon-bubble');
      if (cartButton && !cartDrawer.classList.contains('active')) {
        cartButton.click();
        return;
      }
      
      // Method 2: Directly add active classes
      cartDrawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
      
      // Add overlay if it exists
      const overlay = document.querySelector('.cart-drawer-overlay, .drawer-overlay');
      if (overlay) {
        overlay.classList.add('active');
      }
      
      // Method 3: Dispatch custom event that theme might listen to
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  // Handle upsell addition errors
  function handleUpsellError(target, XMLHttpRequest, textStatus) {
    // Reset button state
    target.style.opacity = '1';
    target.removeAttribute('disabled');

    // Parse error response
    let errorMessage = 'Failed to add product to cart. Please try again.';
    try {
      const errorData = JSON.parse(XMLHttpRequest.responseText || '{}');
      if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.description) {
        errorMessage = errorData.description;
      }
    } catch (e) {
      // Use default error message if parsing fails
    }

    // Show error notification
    if (window.theme && window.theme.helpers && window.theme.helpers.loadComponent) {
      // Try to use theme's notification system
      window.theme.helpers.loadComponent('notificationToast', () => {
        if (window.theme.NotificationToast) {
          // Create a temporary error notification element
          const errorNotification = document.createElement('div');
          errorNotification.className = 'notification notification--error';
          errorNotification.textContent = errorMessage;
          document.body.appendChild(errorNotification);
          
          // Remove after showing
          setTimeout(() => {
            if (errorNotification.parentNode) {
              errorNotification.parentNode.removeChild(errorNotification);
            }
          }, 5000);
        } else {
          alert(errorMessage);
        }
      });
    } else {
      // Fallback to alert
      alert(errorMessage);
    }

    // Dispatch custom event for error handling
    document.dispatchEvent(new CustomEvent('upsell:item-error', {
      detail: { error: XMLHttpRequest, textStatus: textStatus, target: target }
    }));
  }

  // Handle variant selection change
  function handleVariantChange(select) {
    const selectedOption = select.options[select.selectedIndex];
    const productId = select.dataset.productId;
    const upsellProduct = select.closest('.upsell-product');
    
    if (!upsellProduct) return;
    
    // Update price display
    const priceElement = upsellProduct.querySelector('.upsell-price');
    if (priceElement && selectedOption.dataset.price) {
      const price = parseInt(selectedOption.dataset.price);
      const formattedPrice = formatMoney(price);
      priceElement.textContent = formattedPrice;
    }
    
    // Update button's data-variant-id
    const addButton = upsellProduct.querySelector('.upsell-add-btn');
    if (addButton) {
      addButton.setAttribute('data-variant-id', selectedOption.value);
    }
    
    // Update quantity input max based on inventory
    const quantityInput = upsellProduct.querySelector('.upsell-quantity-input');
    if (quantityInput) {
      // Ensure step attribute is set to prevent validation errors
      quantityInput.setAttribute('step', '1');
      
      if (selectedOption.dataset.inventoryManagement === 'shopify' && selectedOption.dataset.inventoryPolicy === 'deny') {
        const inventory = parseInt(selectedOption.dataset.inventory) || 1;
        quantityInput.setAttribute('max', inventory);
        
        // Adjust current value if it exceeds new max
        const currentVal = parseInt(quantityInput.value) || 1;
        if (currentVal > inventory) {
          quantityInput.value = inventory;
        }
      } else {
        quantityInput.setAttribute('max', '10'); // Default max
      }
    }
  }

  // Simple money formatting function (fallback)
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents);
    }
    // Fallback formatting
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars} USD`;
  }

  // Add handlers for quantity buttons and variant selection
  document.addEventListener('click', function(e) {
    // Plus button handler
    if (e.target.matches('.upsell-quantity .oci-plus')) {
      e.preventDefault();
      const input = e.target.closest('.upsell-quantity').querySelector('.upsell-quantity-input');
      const currentVal = parseInt(input.value) || 1;
      const max = parseInt(input.getAttribute('max')) || 1;
      if (currentVal < max) {
        input.value = currentVal + 1;
      }
    }
    
    // Minus button handler
    if (e.target.matches('.upsell-quantity .oci-minus')) {
      e.preventDefault();
      const input = e.target.closest('.upsell-quantity').querySelector('.upsell-quantity-input');
      const currentVal = parseInt(input.value) || 1;
      const min = parseInt(input.getAttribute('min')) || 1;
      if (currentVal > min) {
        input.value = currentVal - 1;
      }
    }
    
    // Close upsell section handler
    if (e.target.closest('.upsell-products1__close')) {
      const upsellSection = e.target.closest('.upsell-products1');
      if (upsellSection) {
        upsellSection.style.display = 'none';
      }
    }
  });

  // Add handler for variant selection changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('.upsell-variant-select')) {
      e.stopPropagation(); // Prevent Shopify's cart validation from triggering
      handleVariantChange(e.target);
    }
  }, true); // Use capture phase to catch event early

  // Add handler for direct input
  document.addEventListener('change', function(e) {
    if (e.target.matches('.upsell-quantity-input')) {
      e.stopPropagation(); // Prevent Shopify's cart validation from triggering
      
      const min = parseInt(e.target.getAttribute('min')) || 1;
      const max = parseInt(e.target.getAttribute('max')) || 1;
      let val = parseInt(e.target.value) || min;

      if (val < min) {
        val = min;
      } else if (val > max) {
        val = max;
      }

      e.target.value = val;
    }
  }, true); // Use capture phase to catch event early

  // Initialize when DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Any initialization code can go here
  });

})();